import { PartialToast, Toast } from '../entities/toast.entity';

export abstract class ShAbstractToastService {
    abstract addToast(toast: Toast): void;
    abstract updateToast(toastId: number, toast: PartialToast): void;
    abstract closeToast(toastId: number): void;
}
